import store from 'app/store/store';
import { getLessonItems, getLessonItemV3 } from 'core/crud/lesson.crud';
import { validateLessonItem } from 'core/models/lessonItem.model';
import { getGuidCourseByTemplate } from 'core/utils/course';
import {
  addUserInfoToJob,
  canUseTangerineViewer,
  canUseTangerineViewerInPreview,
  getAssignedUsersToLessonItem,
  getIconByContentType,
  getRouteProjectionByContentType,
  getTypeNameByContentType,
  getUsePdfTron,
  isDueDate,
} from 'core/utils/lessonItems';
import { isStudent } from 'core/utils/user';
import { CLIENT } from 'core/variables/constant';
import i18next from 'i18next';

function normalizeJob(job) {
  if (!job) return null;
  return job?.id ? { ...job, guid: job.id } : job;
}

async function getStudentJob(jobs, lessonItemGuid, courseGuid) {
  const studentJob = normalizeJob(jobs?.[0]);
  if (studentJob) return studentJob;
  const v2Response = await getLessonItems(lessonItemGuid, courseGuid);
  return normalizeJob(v2Response?.data?.data?.job) ?? null;
}

export async function getLessonItemService(lessonItemGuid, lessonGuid, course, currentUser) {
  const enableAdvancedProgramming = store.getState().systemSettings.settings?.enable_advanced_programming === 1;
  const client = store.getState().organization.tenant;
  if (
    enableAdvancedProgramming ||
    client === CLIENT.TANGERINE ||
    client === CLIENT.SANTILLANA_BRASIL_DEMO ||
    client === CLIENT.SANTILLANA_BRASIL_COMPARTILHA ||
    client === CLIENT.SANTILLANA_BRASIL_UNOI_ON_PREM ||
    client === CLIENT.SANTILLANA_BRASIL_COMPARTILHA_ON_PREM
  ) {
    const courseGuid = course?.guid;
    try {
      const { data } = await getLessonItemV3(lessonItemGuid, lessonGuid, courseGuid);
      const job = isStudent(currentUser) ? await getStudentJob(data?.data?.jobs, lessonItemGuid, courseGuid) : null;

      return {
        ...validateLessonItem(data?.data),
        assignedUsers: getAssignedUsersToLessonItem(data?.data, course),
        allUsers: addUserInfoToJob(data?.data?.jobs, course?.users, data?.data?.lesson_item_guid, courseGuid),
        jobs: addUserInfoToJob(data?.data?.jobs, getAssignedUsersToLessonItem(data?.data, course), data?.data?.lesson_item_guid, courseGuid),
        job,
        icon: getIconByContentType(data?.data?.content_type_guid),
        typeName: data?.data?.content_type_guid ? i18next.t(`lesson:${getTypeNameByContentType(data?.data?.content_type_guid)}`) : '',
        routeProjection: getRouteProjectionByContentType(data?.data?.content_guid, data?.data?.content_type_guid),
        usePdfTron: getUsePdfTron(data?.data?.content_type_guid),
        isDueDate: isDueDate(data?.data?.content_type_guid),
        useTangerineViewer: canUseTangerineViewer(data?.data?.content_type_guid),
        useTangerineViewerInPreview: canUseTangerineViewerInPreview(data?.data?.content_type_guid),
      };
    } catch (error) {
      return Promise.reject({
        status: error?.response?.status || 500,
        message: 'error',
        error,
      });
    }
  } else {
    const lessonItem = await getLessonItems(lessonItemGuid, course?.guid);
    return {
      ...lessonItem?.data?.data,
      assignedUsers: getAssignedUsersToLessonItem(lessonItem?.data?.data, course),
      allUsers: addUserInfoToJob(lessonItem?.data?.data?.jobs, course?.users, lessonItemGuid, getGuidCourseByTemplate(course)),
      jobs: addUserInfoToJob(
        lessonItem?.data?.data?.jobs,
        getAssignedUsersToLessonItem(lessonItem?.data?.data, course),
        lessonItemGuid,
        getGuidCourseByTemplate(course)
      ),
    };
  }
}
